<template>

  <div>

    <el-row style="padding-top: 0.5em;">
      <el-col :xs="24" :sm="24" :md="24" :lg="24">

        <dashboard  />

      </el-col>
    </el-row>

  </div>

</template>

<script>

import Dashboard from '@/components/dashboard/Dashboard'

export default {

  components: {
    Dashboard
  },

  data () {

    return {
      title: 'Overall'
    }

  },

  created () {

    if (this.isProjectView()) {
      this.title = 'Project'
    }

    if (this.isMaintView()) {
      this.title = 'Maintenance'
    }

    if (this.isPropertyView()) {
      this.title = 'Property'
    }

    if (this.isFinanceView()) {
      this.title = 'Finance'
    }


    if (this.isBackhaulView()) {
      this.title = 'Backhaul'
    }

  }

}
</script>



// WEBPACK FOOTER //
// TowerView.vue?42234252